<template>
  <q-dialog
    v-model="dialog"
    style="max-width: 500px"
    persistent
    class="custom-font text-uppercase"
  >
    <q-card class="full-width pragma-black text-white">
      <q-form @submit.prevent="save()">
        <q-card-section class="q-pa-none text-white">
          <q-toolbar
            class="bg-pragma"
          >
            <span class="text-bold">Nueva devolución</span>
            <q-space></q-space>
            <q-btn
              icon="clear"
              flat
              @click="closeDialog()"
            ></q-btn>
          </q-toolbar>
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-xs-12">
              <q-select
                v-model="form.cuenta_id"
                :options="cuentas"
                :option-label="val => `${val.numero} (${val.banco.nombre})`"
                option-value="id"
                label="Cuenta/Banco"
                :rules="[v => !!v || 'Requerido']"
                dense
                outlined
                label-color="grey"
                dark
                emit-value
                map-options
                :loading="loading_cuentas"
              ></q-select>
            </div>
            <div class="col-xs-12 q-pb-lg">
              <q-input
                v-model="form.comprobante"
                label="Número de comprobante"
                class="iu"
                dense
                outlined
                label-color="grey"
                dark
              ></q-input>
            </div>
            <!-- <div class="col-xs-12">
              <q-input
                v-model="form.fechafactura"
                label="Fecha Factura / Recibo"
                dense
                outlined
                label-color="grey"
                dark
                :rules="[v => !!v || 'Requerido']"
                readonly>
                <template v-slot:append>
                  <q-icon name="event" class="cursor-pointer">
                    <q-popup-proxy ref="qDateProxy" cover transition-show="scale" transition-hide="scale">
                      <q-date v-model="form.fechafactura" mask="DD/MM/YYYY" color="blue-grey" dark>
                        <div class="row items-center justify-end">
                          <q-btn v-close-popup label="Aceptar" color="white" flat />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </div> -->
            <div class="col-xs-12">
              <q-input
                v-model="form.detalle"
                label="Detalle"
                class="tu"
                autogrow
                :rules="[v => !!v || 'Requerido']"
                outlined
                dense
                label-color="grey"
                dark
              />
            </div>
            <div class="col-xs-12">
              <q-input
                type="number"
                v-model="form.monto"
                label="Monto"
                :rules="[v => !!v || 'Requerido', v => v >= 0 || 'El precio unitario debe ser mayor a 0', v => v < 9999999999 || 'La cantidad es muy grande']"
                dense
                outlined
                label-color="grey"
                dark
                step="0.01"
              ></q-input>
            </div>
          </div>
        </q-card-section>
        <q-card-actions>
          <div class="row full-width">
            <div class="col-xs-12 q-pa-sm">
              <q-btn
                type="submit"
                label="Realizar devolución"
                color="positive"
                icon="check"
                class="full-width"
                :loading="loading"
              ></q-btn>
            </div>
          </div>
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import { inject, ref } from 'vue'
import axios from 'axios'
import { useQuasar } from 'quasar'
export default {
  setup () {
    // Variables
    const dialog = ref(false)
    const loading = ref(false)
    const form = ref({})
    const cuentas = ref([])
    const loading_cuentas = ref(false)

    const bus = inject('bus')
    const $q = useQuasar()

    // Métodos y funciones
    const getCuentasBanco = async (empresa_id) => {
      try {
        loading_cuentas.value = true
        let res = await axios.get(`cuentas/empresa/${empresa_id}`)
        cuentas.value = res.data
        loading_cuentas.value = false
      } catch (error) {
        console.log(error)
      }
    }

    const save = async () => {
      try {
        loading.value = true
        await axios.post('rendir/solicitud/devolucion', form.value)
        bus.emit('refreshRendicion')
        loading.value = false
        $q.notify({
          message: 'Devolución registrada',
          color: 'positive'
        })
        closeDialog()
      } catch (error) {
        loading.value = false
        console.log(error)
      }
    }

    const closeDialog = ()  => {
      form.value = {}
      loading.value = false
      dialog.value = false
    }

    // Creación del componente
    bus.on('openDialogAddDevolucion', (data) => {
      form.value.solicitud_id = data.id
      getCuentasBanco(data.empresa_id)
      dialog.value = true
    })
    // Template
    return {
      dialog,
      loading,
      form,
      cuentas,
      closeDialog,
      save,
      loading_cuentas
    }
  }
}
</script>

<style>

</style>